import { render } from "./LoginForm.vue?vue&type=template&id=40a551e8"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"
script.render = render

export default script